// Design tokens — extracted from sensors-v2's visual language and used as the
// reference vocabulary while we iteratively repaint the rest of the app.
// Strategy: hybrid — tokens formalized now, components emerge as patterns repeat.

export const TOKENS = {
  color: {
    // Severity (mirrors sensors-v2 severityColor)
    severity: {
      high:   { bg: '#fee2e2', text: '#dc2626', bar: '#dc2626' },
      medium: { bg: '#fef3c7', text: '#d97706', bar: '#d97706' },
      low:    { bg: '#dcfce7', text: '#16a34a', bar: '#16a34a' },
    },
    // Neutrals
    surface: '#f9fafb',          // page background
    surfaceStrong: '#e2e8f0',    // visibly contrasting band (table headers, footers)
    rowAlt:  '#fafbfc',          // zebra-stripe alternate row
    rowHover:'#eef4ff',          // row hover tint (slight action wash)
    card:    '#ffffff',          // card background
    border:  '#e5e7eb',          // hairline border on cards / dividers
    divider: '#f3f4f6',          // softer divider inside cards
    text:    '#111827',          // primary text
    muted:   '#6b7280',          // secondary text / labels
    // Action — kept on Metronic primary so existing CTAs blend in
    action:     '#2563eb',
    actionSoft: '#dbeafe',
  },
  radius: {
    chip: 6,
    card: 10,
    hero: 12,
  },
  spacing: {
    xs:  4,
    sm:  8,
    md:  12,
    lg:  16,
    xl:  24,
    xxl: 32,
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.04)',
    hover: '0 4px 12px rgba(0,0,0,0.06)',
  },
  typography: {
    // Sizes match what sensors-v2 already uses (Metronic fs-* scale equivalents)
    label:     { size: 10, weight: 700, transform: 'uppercase' as const, tracking: 0.5 },
    body:      { size: 13, weight: 400 },
    title:     { size: 14, weight: 700 },
    kpiSmall:  { size: 22, weight: 700 },
    kpiLarge:  { size: 32, weight: 700 },
  },
} as const;

export type SeverityLevel = keyof typeof TOKENS.color.severity;
